
// import React, {
//   useEffect,
//   useRef,
//   useState,
// } from "react";

// import { eMandateUrl } from "../../config/taskApi";

// const getSessionData = () => {
//   try {
//     const keys = Object.keys(sessionStorage);

//     for (const key of keys) {
//       const value = sessionStorage.getItem(key);

//       if (!value) continue;

//       try {
//         const parsed = JSON.parse(value);

//         if (parsed && parsed.lead_id) {
//           return parsed;
//         }
//       } catch {
//         // Ignore non-JSON session values
//       }
//     }

//     return null;
//   } catch {
//     return null;
//   }
// };

// const EMandatePage = ({ onContinue }) => {
//   const [seconds, setSeconds] = useState(3);

//   const [apiLoading, setApiLoading] =
//     useState(true);

//   const [apiSuccess, setApiSuccess] =
//     useState(false);

//   const [apiMessage, setApiMessage] =
//     useState("");

//   const [paymentUrl, setPaymentUrl] =
//     useState("");

//   const apiCalledRef = useRef(false);

//   const sessionData = getSessionData();

//   const leadId =
//     sessionData?.lead_id || "";

//   const email =
//     sessionData?.email || "";

//   const phone =
//     sessionData?.customer_mobile ||
//     sessionData?.phone ||
//     "";

//   const amount =
//     sessionData?.loan_amount ||
//     sessionData?.amount ||
//     "";

//   // Exact name path from your session structure
//   const fullName =
//     sessionData?.saved_fields
//       ?.aadhaar_profile?.name || "";

//   // First word from full name
//   const firstName =
//     String(fullName)
//       .trim()
//       .split(/\s+/)[0] || "";

//   console.log(
//     "eMandate Session Data:",
//     sessionData
//   );

//   console.log(
//     "eMandate Lead ID:",
//     leadId
//   );

//   console.log(
//     "eMandate Full Name:",
//     fullName
//   );

//   console.log(
//     "eMandate First Name:",
//     firstName
//   );

//   console.log(
//     "eMandate Email:",
//     email
//   );

//   console.log(
//     "eMandate Phone:",
//     phone
//   );

//   console.log(
//     "eMandate Amount:",
//     amount
//   );

//   // =====================================================
//   // COUNTDOWN
//   // =====================================================

//   useEffect(() => {
//     if (seconds <= 0) {
//       return;
//     }

//     const timer = setInterval(() => {
//       setSeconds((prev) =>
//         prev > 0 ? prev - 1 : 0
//       );
//     }, 1000);

//     return () => {
//       clearInterval(timer);
//     };
//   }, [seconds]);

//   // =====================================================
//   // E-MANDATE API
//   // PAGE OPEN HOTE HI CALL HOGI
//   // =====================================================

//   useEffect(() => {
//     const generateMandate = async () => {
//       if (!leadId) {
//         setApiLoading(false);
//         setApiSuccess(false);
//         setApiMessage(
//           "Lead ID is missing."
//         );
//         return;
//       }

//       if (!firstName) {
//         setApiLoading(false);
//         setApiSuccess(false);
//         setApiMessage(
//           "Customer name is missing."
//         );
//         return;
//       }

//       try {
//         setApiLoading(true);
//         setApiSuccess(false);
//         setApiMessage("");
//         setPaymentUrl("");

//         const formData =
//           new URLSearchParams();

//         formData.append(
//           "lead_id",
//           String(leadId)
//         );

//         formData.append(
//           "firstname",
//           String(firstName)
//         );

//         formData.append(
//           "email",
//           String(email)
//         );

//         formData.append(
//           "phone",
//           String(phone)
//         );

//         formData.append(
//           "amount",
//           String(amount)
//         );

//         console.log(
//           "eMandate Request:",
//           {
//             lead_id: leadId,
//             firstname: firstName,
//             email,
//             phone,
//             amount,
//           }
//         );

//         const response = await fetch(
//           eMandateUrl(),
//           {
//             method: "POST",
//             headers: {
//               "Content-Type":
//                 "application/x-www-form-urlencoded",
//             },
//             body: formData.toString(),
//           }
//         );

//         const data =
//           await response.json();

//         console.log(
//           "eMandate API Response:",
//           data
//         );

//         const status =
//           data?.status === true ||
//           data?.status === 1 ||
//           data?.status === "1" ||
//           data?.status === "true";

//         const message =
//           data?.message ||
//           data?.msg ||
//           "Unable to generate e-mandate.";

//         const generatedPaymentUrl =
//           data?.payment_url || "";

//         if (status) {
//           setApiSuccess(true);

//           setPaymentUrl(
//             generatedPaymentUrl
//           );

//           setApiMessage(message);

//           console.log(
//             "eMandate API SUCCESS"
//           );

//           console.log(
//             "Payment URL:",
//             generatedPaymentUrl
//           );

//           /*
//            * Open the payment URL in a new tab.
//            */
//           // if (generatedPaymentUrl) {
//           //   const newTab =
//           //     window.open(
//           //       generatedPaymentUrl,
//           //       "_blank"
//           //     );

//           //   if (!newTab) {
//           //     console.warn(
//           //       "Browser blocked the new tab."
//           //     );

//           //     setApiMessage(
//           //       `${message} Please allow pop-ups to continue with e-mandate.`
//           //     );
//           //   }
//           // } else {
//           //   console.warn(
//           //     "Payment URL missing in API response."
//           //   );

//           //   setApiMessage(
//           //     "E-mandate generated successfully, but payment URL was not received."
//           //   );
//           // }
//           if (status) {
//   setApiSuccess(true);
//   setPaymentUrl(generatedPaymentUrl);
//   setApiMessage(message);

//   console.log("eMandate API SUCCESS");
//   console.log("Payment URL:", generatedPaymentUrl);

//   if (!generatedPaymentUrl) {
//     setApiSuccess(false);
//     setApiMessage(
//       "E-mandate generated successfully, but payment URL was not received."
//     );
//   }
// }
//         } else {
//           setApiSuccess(false);
//           setApiMessage(message);

//           console.log(
//             "eMandate API FAILED:",
//             message
//           );
//         }
//       } catch (error) {
//         console.error(
//           "eMandate API Error:",
//           error
//         );

//         setApiSuccess(false);

//         setApiMessage(
//           error?.message ||
//             "Unable to generate e-mandate. Please try again."
//         );
//       } finally {
//         setApiLoading(false);
//       }
//     };

//     /*
//      * React StrictMode development mein effect
//      * ko do baar run kar sakta hai.
//      *
//      * Isliye API ko sirf ek baar call karenge.
//      */
//     if (!apiCalledRef.current) {
//       apiCalledRef.current = true;
//       generateMandate();
//     }
//   }, [
//     leadId,
//     firstName,
//     email,
//     phone,
//     amount,
//   ]);

//   // =====================================================
//   // CONTINUE CONDITION
//   // =====================================================

//   const canContinue =
//     seconds === 0 &&
//     apiSuccess;

//   // =====================================================
//   // UI
//   // =====================================================

//   return (
//     <section className="fw-screen fw-screen--emandate fw-fade">
//       <div className="fw-emandate">

//         <div className="fw-emandate__dots">
//           <span />
//           <span />
//         </div>

//         <div className="fw-emandate__content">

//           <h1 className="fw-emandate__title">
//             Complete your E-mandate
//           </h1>

//           <p className="fw-emandate__text">
//             After completing e-mandate process
//             <br />
//             come back to the application for further
//             <br />
//             process.
//           </p>

//           {/* API STATUS */}
//           {apiLoading && (
//             <p className="fw-emandate__status">
//               Generating your e-mandate request...
//             </p>
//           )}

//           {!apiLoading &&
//             apiSuccess &&
//             apiMessage && (
//               <p className="fw-emandate__status is-success">
//                 {apiMessage}
//               </p>
//             )}

//           {!apiLoading &&
//             !apiSuccess &&
//             apiMessage && (
//               <p className="fw-emandate__status is-error">
//                 {apiMessage}
//               </p>
//             )}

//         </div>

//         {/* CONTINUE BUTTON */}

//         <button
//           type="button"
//           className="fw-btn fw-btn--dark fw-btn--full fw-emandate__button"
//           disabled={!canContinue}
//           // onClick={onContinue}
//           onClick={() => {
//   if (!paymentUrl || !apiSuccess) {
//     return;
//   }

//   window.open(
//     paymentUrl,
//     "_blank",
//     "noopener,noreferrer"
//   );

//   onContinue();
// }}
//         >
//           {apiLoading
//             ? "Generating..."
//             : seconds > 0
//             ? `Continue in ${seconds}s`
//             : apiSuccess
//             ? "Continue"
//             : "Unable to Continue"}
//         </button>

//       </div>
//     </section>
//   );
// };

// export default EMandatePage;


import React, {
  useEffect,
  useRef,
  useState,
} from "react";

import { eMandateUrl } from "../../config/taskApi";
import { getCustomerSession } from "../../utils/applyFlowSession";

const pickTrimmed = (...values) => {
  for (const value of values) {
    const text = String(value ?? "").trim();
    if (text) return text;
  }
  return "";
};

const getSessionData = () => {
  // Prefer apply-new customer session (local + session storage)
  const customer = getCustomerSession();
  if (customer?.lead_id || customer?.saved_fields) {
    return customer;
  }

  try {
    const keys = Object.keys(sessionStorage);

    for (const key of keys) {
      const value = sessionStorage.getItem(key);
      if (!value) continue;

      try {
        const parsed = JSON.parse(value);
        if (parsed && parsed.lead_id) {
          return parsed;
        }
      } catch {
        // Ignore non-JSON session values
      }
    }

    return null;
  } catch {
    return null;
  }
};

const resolveEMandateEmail = (session, propEmail = "") => {
  const fields = session?.saved_fields || {};
  return pickTrimmed(
    propEmail,
    session?.email,
    session?.email_personal,
    session?.email_id,
    fields.email,
    fields.email_personal,
    fields.email_id,
    fields.email_official
  );
};

const resolveEMandatePhone = (session, propPhone = "") =>
  pickTrimmed(
    propPhone,
    session?.customer_mobile,
    session?.phone,
    session?.mobile,
    session?.saved_fields?.mobile,
    session?.saved_fields?.phone
  ).replace(/\D/g, "").slice(-10);

const resolveEMandateAmount = (session, propAmount = "") =>
  pickTrimmed(
    propAmount,
    session?.loan_amount,
    session?.amount,
    session?.saved_fields?.loan_amount,
    session?.saved_fields?.amount
  );

const resolveEMandateName = (session, propName = "") => {
  const fields = session?.saved_fields || {};
  const profile = fields.aadhaar_profile || {};
  return pickTrimmed(
    propName,
    profile.name,
    profile.full_name,
    fields.full_name,
    fields.name,
    session?.full_name,
    session?.name,
    [fields.first_name, fields.middle_name, fields.last_name || fields.sur_name]
      .filter(Boolean)
      .join(" ")
  );
};

const EMandatePage = ({
  onContinue,
  email: emailProp = "",
  phone: phoneProp = "",
  amount: amountProp = "",
  fullName: fullNameProp = "",
  leadId: leadIdProp = "",
}) => {
  const [seconds, setSeconds] = useState(3);

  const [apiLoading, setApiLoading] = useState(true);

  const [apiSuccess, setApiSuccess] = useState(false);

  const [apiMessage, setApiMessage] = useState("");

  const [paymentUrl, setPaymentUrl] = useState("");

  const apiCalledRef = useRef(false);

  const sessionData = getSessionData();
  const saved = sessionData?.saved_fields || {};

  const leadId = pickTrimmed(
    leadIdProp,
    sessionData?.lead_id,
    sessionData?.aa_lead_id,
    saved.lead_id
  );

  // Email often lives in saved_fields (not top-level session.email)
  const email = resolveEMandateEmail(sessionData, emailProp);

  const phone = resolveEMandatePhone(sessionData, phoneProp);

  const amount = resolveEMandateAmount(sessionData, amountProp);

  const fullName = resolveEMandateName(sessionData, fullNameProp);

  const firstName =
    String(fullName).trim().split(/\s+/)[0] || "";

  console.log(
    "eMandate Session Data:",
    sessionData
  );

  console.log(
    "eMandate Lead ID:",
    leadId
  );

  console.log(
    "eMandate Full Name:",
    fullName
  );

  console.log(
    "eMandate First Name:",
    firstName
  );

  console.log(
    "eMandate Email:",
    email
  );

  console.log(
    "eMandate Phone:",
    phone
  );

  console.log(
    "eMandate Amount:",
    amount
  );

  // =====================================================
  // COUNTDOWN
  // =====================================================

  useEffect(() => {
    if (seconds <= 0) {
      return;
    }

    const timer = setInterval(() => {
      setSeconds((prev) =>
        prev > 0 ? prev - 1 : 0
      );
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [seconds]);

  // =====================================================
  // E-MANDATE API
  // PAGE OPEN HOTE HI CALL HOGI
  // =====================================================

  useEffect(() => {
    const generateMandate = async () => {
      if (!leadId) {
        setApiLoading(false);
        setApiSuccess(false);
        setApiMessage(
          "Lead ID is missing."
        );
        return;
      }

      if (!firstName) {
        setApiLoading(false);
        setApiSuccess(false);
        setApiMessage(
          "Customer name is missing."
        );
        return;
      }

      if (!email) {
        setApiLoading(false);
        setApiSuccess(false);
        setApiMessage(
          "Email is missing. Please go back and enter your email."
        );
        return;
      }

      try {
        setApiLoading(true);
        setApiSuccess(false);
        setApiMessage("");
        setPaymentUrl("");

        const formData = new URLSearchParams();

        formData.append(
          "lead_id",
          String(leadId)
        );

        formData.append(
          "firstname",
          String(firstName)
        );

        formData.append(
          "email",
          String(email)
        );

        formData.append(
          "phone",
          String(phone)
        );

        formData.append(
          "amount",
          String(amount)
        );

        console.log(
          "eMandate Request:",
          {
            lead_id: leadId,
            firstname: firstName,
            email,
            phone,
            amount,
          }
        );

        const response = await fetch(
          eMandateUrl(),
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
          }
        );

        if (!response.ok) {
          throw new Error(
            `eMandate API failed with status ${response.status}`
          );
        }

        const data = await response.json();

        console.log(
          "eMandate API Response:",
          data
        );

        const status =
          data?.status === true ||
          data?.status === 1 ||
          data?.status === "1" ||
          data?.status === "true";

        const message =
          data?.message ||
          data?.msg ||
          "Unable to generate e-mandate.";

        const generatedPaymentUrl =
          data?.payment_url || "";

        console.log(
          "eMandate Status:",
          data?.status
        );

        console.log(
          "eMandate Status After Check:",
          status
        );

        if (status) {
          console.log(
            "eMandate API SUCCESS"
          );

          console.log(
            "Payment URL:",
            generatedPaymentUrl
          );

          if (!generatedPaymentUrl) {
            setApiSuccess(false);
            setApiMessage(
              "E-mandate generated successfully, but payment URL was not received."
            );
          } else {
            setApiSuccess(true);
            setPaymentUrl(
              generatedPaymentUrl
            );
            setApiMessage(message);
          }
        } else {
          console.log(
            "eMandate API FAILED:",
            message
          );

          setApiSuccess(false);
          setApiMessage(message);
        }
      } catch (error) {
        console.error(
          "eMandate API Error:",
          error
        );

        setApiSuccess(false);

        setApiMessage(
          error?.message ||
            "Unable to generate e-mandate. Please try again."
        );
      } finally {
        setApiLoading(false);
      }
    };

    /*
     * Prevent duplicate API call in React development mode.
     * Wait until required fields (incl. email) are present before locking.
     */
    if (!leadId || !firstName || !email) {
      setApiLoading(false);
      setApiSuccess(false);
      if (!leadId) {
        setApiMessage("Lead ID is missing.");
      } else if (!firstName) {
        setApiMessage("Customer name is missing.");
      } else {
        setApiMessage(
          "Email is missing. Please go back and enter your email."
        );
      }
      return;
    }

    if (!apiCalledRef.current) {
      apiCalledRef.current = true;
      generateMandate();
    }
  }, [
    leadId,
    firstName,
    email,
    phone,
    amount,
  ]);

  // =====================================================
  // CONTINUE CONDITION
  // =====================================================

  const canContinue =
    seconds === 0 &&
    apiSuccess &&
    Boolean(paymentUrl);

  // =====================================================
  // CONTINUE HANDLER
  // =====================================================

  const handleContinue = () => {
    if (!canContinue) {
      return;
    }

    console.log(
      "Opening eMandate Payment URL:",
      paymentUrl
    );

    const newTab = window.open(
      paymentUrl,
      "_blank",
      // "noopener,noreferrer"
    );

    if (!newTab) {
      setApiMessage(
        "Popup was blocked. Please allow pop-ups and try again."
      );
      return;
    }

    onContinue();
  };

 

  return (
    <section className="fw-screen fw-screen--emandate fw-fade">
      <div className="fw-emandate">

        <div className="fw-emandate__dots">
          <span />
          <span />
        </div>

        <div className="fw-emandate__content">

          <h1 className="fw-emandate__title">
            Complete your E-mandate
          </h1>

          <p className="fw-emandate__text">
            After completing e-mandate process
            <br />
            come back to the application for further
            <br />
            process.
          </p>

          {apiLoading && (
            <p className="fw-emandate__status">
              Generating your e-mandate request...
            </p>
          )}

          {!apiLoading &&
            apiSuccess &&
            apiMessage && (
              <p className="fw-emandate__status is-success">
                {apiMessage}
              </p>
            )}

          {!apiLoading &&
            !apiSuccess &&
            apiMessage && (
              <p className="fw-emandate__status is-error">
                {apiMessage}
              </p>
            )}

        </div>

        <button
          type="button"
          className="fw-btn fw-btn--dark fw-btn--full fw-emandate__button"
          disabled={!canContinue}
          onClick={handleContinue}
        >
          {apiLoading
            ? "Generating..."
            : seconds > 0
            ? `Continue in ${seconds}s`
            : apiSuccess
            ? "Continue"
            : "Unable to Continue"}
        </button>

      </div>
    </section>
  );
};

export default EMandatePage;